declare global {
    interface Window {
        __APP_CONFIG__?: {
            PROD?: string | boolean;
            API_URL?: string;
            API_VERSION?: string;
            AUTH_REALM?: string;
            AUTH_URL?: string;
            AUTH_CLIENT_ID?: string;
            SIGNALR_BASE_URL?: string;
            APP_VERSION?: string;
            SENTRY_DSN?: string;
            SENTRY_ENVIRONMENT?: string;
        };
    }
}

export const API_URL = window.__APP_CONFIG__?.API_URL || import.meta.env.VITE_API_URL;
export const API_VERSION = window.__APP_CONFIG__?.API_VERSION || import.meta.env.VITE_API_VERSION;
export const AUTH_REALM = window.__APP_CONFIG__?.AUTH_REALM || import.meta.env.VITE_AUTH_REALM;
export const AUTH_URL = window.__APP_CONFIG__?.AUTH_URL || import.meta.env.VITE_AUTH_URL;
export const AUTH_CLIENT_ID =
    window.__APP_CONFIG__?.AUTH_CLIENT_ID || import.meta.env.VITE_AUTH_CLIENT_ID;
export const SIGNALR_BASE_URL =
    window.__APP_CONFIG__?.SIGNALR_BASE_URL || import.meta.env.VITE_SIGNALR_BASE_URL;
export const APP_VERSION = __APP_VERSION__;
export const SENTRY_DSN = window.__APP_CONFIG__?.SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENVIRONMENT =
    window.__APP_CONFIG__?.SENTRY_ENVIRONMENT || import.meta.env.VITE_SENTRY_ENVIRONMENT;
const PROD = window.__APP_CONFIG__?.PROD || import.meta.env.PROD;
export const isProd = PROD === 'true' || PROD === true;
